import { render, staticRenderFns } from "./OrderHeaderRow.vue?vue&type=template&id=0894498c&scoped=true"
import script from "./OrderHeaderRow.vue?vue&type=script&lang=js"
export * from "./OrderHeaderRow.vue?vue&type=script&lang=js"
import style0 from "./OrderHeaderRow.vue?vue&type=style&index=0&id=0894498c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0894498c",
  null
  
)

export default component.exports